import * as React from "react";
import PropTypes from "prop-types";
import {
  Calendar,
  DateRangeType,
  DayOfWeek,
} from "@fluentui/react-calendar-compat";

export const FluentCalendarDrilldown = ({
  value,
  onSelectDate,
  minDate,
  maxDate,
  today,
  dateRangeType = DateRangeType.Day,
  firstDayOfWeek = DayOfWeek.Sunday,
  showGoToToday = false,
  highlightCurrentMonth = true,
  highlightSelectedMonth = true,
  isMonthPickerVisible = true,
  isDayPickerVisible = true,
  showMonthPickerAsOverlay = true,
  className,
}) => {
  return (
    <Calendar
      value={value ?? undefined}
      today={today}
      onSelectDate={onSelectDate}
      minDate={minDate}
      maxDate={maxDate}
      dateRangeType={dateRangeType}
      firstDayOfWeek={firstDayOfWeek}
      isMonthPickerVisible={isMonthPickerVisible}
      isDayPickerVisible={isDayPickerVisible}
      showMonthPickerAsOverlay={showMonthPickerAsOverlay}
      highlightCurrentMonth={highlightCurrentMonth}
      highlightSelectedMonth={highlightSelectedMonth}
      showGoToToday={showGoToToday}
      className={className}
    />
  );
};

FluentCalendarDrilldown.propTypes = {
  value: PropTypes.instanceOf(Date),
  onSelectDate: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  today: PropTypes.instanceOf(Date),
  dateRangeType: PropTypes.number,
  firstDayOfWeek: PropTypes.number,
  showGoToToday: PropTypes.bool,
  highlightCurrentMonth: PropTypes.bool,
  highlightSelectedMonth: PropTypes.bool,
  isMonthPickerVisible: PropTypes.bool,
  isDayPickerVisible: PropTypes.bool,
  showMonthPickerAsOverlay: PropTypes.bool,
  className: PropTypes.string,
};
